// extracted by mini-css-extract-plugin
export var cardIcon = "_5g-4";
export var checkboxCard = "_5g-0";
export var checkboxCardSelected = "_5g-3";
export var disabled = "_5g-1";
export var outerBorder = "_5g-2";
export var spacerMedium = "_5g-7";
export var spacerSmall = "_5g-6";
export var spacerXsmall = "_5g-5";